module.exports = __webpack_public_path__ + "static/template_options_month-b023dbcf2d182aa4219284701e604fe4.png";